<template>
  <b-overlay
    :show="show"
    :variant="variant"
    :opacity="opacity"
    :blur="blur"
    rounded="lg"
    spinner-variant="primary"
  >
    <b-card>
      <h1>{{ $t("BookAppointment") }}</h1>
      <form
        name="booking_form"
        method="post"
        v-on:submit.prevent="$event.preventDefault()"
      >
        <div class="vx-row">
          <!-- required -->
          <div class="vx-col w-1/2" id="department">
            <label>{{ $t("InMates") }}</label>
            <v-select
              size="large"
              v-model="inmate"
              :options="staffs"
              :reduce="(name) => name.id"
              label="name"
              :placeholder="$t('SelectInMate')"
            >
              <template v-slot:option="option">
                <span :class="option.icon">{{ option.name }} </span>
                <feather-icon
                  v-if="inmate && inmate == option.id"
                  icon="CheckIcon"
                  class="float-right"
                  svgClasses="w-5 h-5"
                />
              </template>
            </v-select>
          </div>
          <div class="vx-col w-1/2" id="department">
            <label>{{ $t("Relative") }} <span class="red">*</span></label>
            <v-select
              size="large"
              v-model="relative"
              v-validate="'required'"
              :options="relatives"
              :reduce="(name) => name.id"
              label="name"
              name="relative"
              :placeholder="$t('SelectRelative')"
              :data-vv-as="$t('Relative')"
            >
              <template v-slot:option="option">
                <span :class="option.icon">{{ option.name }} </span>
                <feather-icon
                  v-if="relative && relative == option.id"
                  icon="CheckIcon"
                  class="float-right"
                  svgClasses="w-5 h-5"
                />
              </template>
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('relative')">{{
              errors.first("relative")
            }}</span>
          </div>
          <div :key="refershCal" class="vx-col w-1/2 mt-10">
            <functional-calendar
              :limits="{ min: currentDate, max: endDate }"
              :is-date-picker="true"
              :markedDates="slots"
              :disabledDates="disabledDates"
              @dayClicked="getTimeSlots"
              :hidden-elements="['leftAndRightDays']"
              :isLayoutExpandable="true"
              :dayNames="days"
              :monthNames="months"
            ></functional-calendar>
          </div>
          <div class="vx-col w-1/2 mt-20">
            <div v-if="slotMsg" class="vx-row">
              <div
                v-for="(slot, index) in timeSlots"
                :key="index"
                class="vx-col"
              >
                <button
                  class="mt-3 b-sh py-2 px-5 sbtn"
                  :class="'s' + index"
                  @click="timeSlotSelected(slot, index)"
                >
                  {{ slot.start_time }}
                </button>
              </div>
            </div>
            <div
              v-if="!slotMsg"
              class="justify-content-center align-items-center my-8"
            >
              <div class="mt-3 mr-3">{{ $t("TimeSlotNotAvailable") }}</div>
            </div>
          </div>
        </div>

        <div class="vx-col" id="update">
          <b-button
            variant="primary"
            type="filled"
            @click.prevent="bookForm"
            class="mt-5 block"
            :disabled="!selectedTime.start_time"
            >{{ $t("Book") }}</b-button
          >

          <router-link :to="'/company/appointment'">
            <b-button
              variant="border"
              class="mt-5 br-20 pl-5 pr-5 border-primary text-primary"
              id="cancel"
              type="border"
              >{{ $t("Cancel") }}</b-button
            >
          </router-link>
        </div>
      </form>
      <!-- popup -->
      <!--  -->
    </b-card>
  </b-overlay>
</template>
<script>
import vSelect from "vue-select";
import moment from "moment";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import $ from "jquery";
// For custom error message
import { Validator } from "vee-validate";

export default {
  components: {
    FormWizard,
    TabContent,
    "v-select": vSelect,
  },
  data() {
    return {
      bookNow: false,
      staffs: [],
      relatives: [],
      inmate: "",
      relative: "",
      slots_availablity: [],
      currentDate: moment(new Date(), "D/M/YYYY").format("D/M/YYYY"),
      endDate: moment(new Date(), "MM/DD/YYYY")
        .add(1, "M")
        .endOf("month")
        .format("D/M/YYYY"),
      disabledDates: [],
      days: this.$t("dayNames"),
      months: this.$t("monthNames"),
      staffList: [],
      slotMsg: false,
      dateMarked: [],
      slots: [],
      currentSelectedDate: "",
      type: "normal",
      showConfirmation: false,
      dateSel: "",
      selectedCurrentDate: "",
      timeZone: "",
      selectedTime: "",
      users: [],
      cancelAppointment: "",
      timeSlots: [],
      refershCal: 1,
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,
    };
  },
  watch: {
    "$i18n.locale": {
      handler: function (value) {
        this.loadLocale(value);
        this.displayError();
      },
    },
    inmate(value) {
      this.getInmateData();
    },
    relative(value) {
      this.getAvailableDates();
    },
  },

  created() {
    this.$validator.extend("upCase", {
      getMessage: () => this.$t("errorMessage"),
      validate: (value) => value.match(/[A-Z]/g) !== null,
    });
    this.$validator.extend("numbers", {
      getMessage: () => this.$t("errorMessage"),
      validate: (value) => value.match(/[0-9]/g) !== null,
    });
    this.$validator.extend("loCase", {
      getMessage: () => this.$t("errorMessage"),
      validate: (value) => value.match(/[a-z]/g) !== null,
    });

    this.loadLocale(this.$i18n.locale);
    this.getStaffs();
    this.timeZone = this.$store.getters.currentUser.timezone;
    this.getDisabledDates();
  },

  methods: {
    //display error
    displayError() {
      this.$validator.extend("upCase", {
        getMessage: () => this.$t("errorMessage"),
        validate: (value) => value.match(/[A-Z]/g) !== null,
      });
      this.$validator.extend("numbers", {
        getMessage: () => this.$t("errorMessage"),
        validate: (value) => value.match(/[0-9]/g) !== null,
      });
      this.$validator.extend("loCase", {
        getMessage: () => this.$t("errorMessage"),
        validate: (value) => value.match(/[a-z]/g) !== null,
      });
    },
    // Error Message
    errorClass(rule) {
      return {
        error: this.errors.firstByRule("password", rule),
      };
    },

    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },

    /**
     * get staffs
     */
    getStaffs() {
      this.show = true;
      let data = {
        company_id: this.$store.getters.currentUser.id,
        is_inmate: 1,
      };
      this.$store
        .dispatch("GetStaffList", data)
        .then((res) => {
          this.show = false;
          this.staffs = res.data.data;
          this.staffs.forEach((element, index) => {
            this.staffs[index].name =
              element.first_name + " " + element.last_name;
            this.staffList[element.id] = element;
          });
        })
        .catch((error) => {
          this.$log.error(
            "File : Add.vue | Function : getstaffs() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.$vs.notify({
            title: this.$t("Error"),
            text:
              this.$t(error.replace(/[\s\/]/g, "")) !==
              error.replace(/[\s\/]/g, "")
                ? this.$t(error.replace(/[\s\/]/g, ""))
                : error,
            color: "danger",
            position: "top-center",
          });
          return false;
        });
    },

    /**
     * get slots
     */
    getTimeSlots(event) {
      this.timeSlots = [];
      this.selectedTime = "";
      $(".sbtn").removeClass("active");
      moment.locale("en");
      this.dateSel = event;
      if (this.dateMarked.includes(event.date)) {
        var day = moment(event.date, "D/M/YYYY").format("dddd");
        this.currentSelectedDate = moment(event.date, "D/M/YYYY").format(
          "dddd, MMMM D, YYYY"
        );
        this.selectedCurrentDate = event.date;
        moment.locale(this.$i18n.locale);
        day = day.toLowerCase();
        var data = {
          day: day,
          id: this.staffList[this.inmate].department_id,
          date: moment(event.date, "D/M/YYYY").format("YYYY-MM-DD"),
          timezone: this.timeZone,
          unio_staff_id: this.inmate,
          is_inperson: 0,
          user_id: this.relative,
        };
        if (this.relative) {
          this.show = true;
          this.$store
            .dispatch("GetDaySlots", data)
            .then((res) => {
              this.show = false;
              this.slotMsg = true;
              this.timeSlots = res.data.data.slots;
              if (this.timeSlots.length <= 0) {
                this.slotMsg = false;
              }
              moment.locale("en");
            })
            .catch((error) => {
              this.$log.error(
                "File : BookInterview.vue | Function : getTimeSlots() | Error :",
                error
              );
              this.show = false;
              return false;
            });
        } else {
          return false;
        }
      }
    },

    /**
     * get in mate data
     */
    getInmateData() {
      this.relative = "";
      this.timeSlots = [];
      this.disabledDates = [];
      this.slots = [];
      this.dateMarked = [];
      this.refershCal += 1;
      this.getRelativeList();
      // this.getAvailableDates();
    },

    /**
     * get relative list
     */
    getRelativeList() {
      this.show = true;
      let data = {
        inmate_id: this.inmate,
      };
      this.$store
        .dispatch("GetRelativeList", data)
        .then((res) => {
          this.show = false;
          this.relatives = res.data.data;
          this.relatives.forEach((element) => {
            this.users[element.id] = element;
          });
        })
        .catch((error) => {
          this.$log.error(
            "File : Add.vue | Function : getRelativeList() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    /**
     * get available dates
     */
    getAvailableDates() {
      this.show = true;
      this.$store
        .dispatch(
          "GetAvailableDates",
          this.staffList[this.inmate].department_id
        )
        .then((res) => {
          this.slotMsg = false;

          if (res.data.status == "success") {
            console.log(res.data.data.disabled_dates);
            res.data.data.disabled_dates.forEach((element) => {
              this.disabledDates.push(
                moment(element, "YYYY-MM-DD").format("YYYY-MM-DD")
              );
            });

            //custome time solts
            res.data.data.custom_slots_availablity.forEach((element) => {
              let array = res.data.data.disabled_dates;
              if (!array.includes(element.day)) {
                this.dateMarked.push(
                  moment(element.day, "YYYY-MM-DD").format("D/M/YYYY")
                );

                this.slots.push({
                  date: moment(element.day, "YYYY-MM-DD").format("D/M/YYYY"),
                  class: "marked-class",
                });
              }
            });

            //$('.marked-class').removeClass('vfc-disabled');

            this.getDisabledDates();

            if (res.data.data.custom_slots_availablity.length <= 0) {
              this.slotMsg = false;
            }
            $(".vfc-today").trigger("click");
          }

          this.show = false;
        })
        .catch((error) => {
          this.$log.error(
            "File : BookInterview.vue | Function : getAvailableDates() | Error :",
            error
          );
          this.show = false;
          return false;
        });
    },

    /**
     * dispabled dates
     */
    getDisabledDates() {
      var startDate = moment();
      var endDate = moment(new Date(), "MM/DD/YYYY").add(1, "M").endOf("month");
      endDate = endDate.format("YYYY-MM-DD");
      while (startDate.isSameOrBefore(endDate, "day")) {
        if (this.dateMarked.includes(startDate.format("D/M/YYYY")) == false) {
          this.disabledDates.push(startDate.format("D/M/YYYY"));
        }
        startDate.add(1, "days");
      }
    },

    /**
     * when time slot selected
     */
    timeSlotSelected(slot, index) {
      this.selectedTime = slot;
      $(".sbtn").removeClass("active");
      $(".s" + index).addClass("active");
      this.bookNow = true;
      console.log("this.selectedTime", this.selectedTime);
    },

    /**
     * book appointment
     */
    bookForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.selectedTime) {
            this.show = true;
            moment.locale("en");

            this.scheduleEvent = this.users[this.relative];

            this.scheduleEvent.appointment_details = {
              company_id: this.staffList[this.inmate].company_id,
              day: moment(
                this.currentSelectedDate,
                "dddd, MMMM D, YYYY"
              ).format("dddd"),
              date: moment(
                this.currentSelectedDate,
                "dddd, MMMM D, YYYY"
              ).format("YYYY-MM-DD"),
              start_time: this.selectedTime.start_time,
              end_time: this.selectedTime.end_time,
              department_id: this.staffList[this.inmate].department_id,
              type: this.type,
              is_rescheduled: this.cancelAppointment ? "1" : "0",
              rescheduled_id: this.cancelAppointment,
            };
            this.scheduleEvent.is_unio = 1;
            // this.scheduleEvent.timezone = this.users[this.relative].timezone;
            this.scheduleEvent.timezone = this.timeZone;
            this.scheduleEvent.is_user_booked = false;
            this.scheduleEvent.is_booked_by_inmate = 1;
            this.scheduleEvent.inmate_id = this.inmate;
            (this.scheduleEvent.is_inperson = 0),
              (this.scheduleEvent.unio_staff_id = this.inmate);
            const data = new FormData();

            $.each(this.scheduleEvent, function (key, value) {
              if (key == "appointment_details") {
                data.append(key, JSON.stringify(value));
              } else {
                if (value == null) {
                  data.append(key, "");
                } else {
                  data.append(key, value);
                }
              }
            });

            console.log("this.scheduleEvent", this.scheduleEvent);
            this.$store
              .dispatch("ScheduleEvent", data)
              .then((res) => {
                this.show = false;
                console.log("------------res============", res);
                this.showConfirmation = true;
                this.selectedTime = [];
                this.timeSlots = [];
                $(".sbtn").removeClass("active");
                this.getTimeSlots(this.dateSel);
                // Success response
                if (res.data.appointment_details.is_booked != true) {
                  this.$toasted.show(this.$t("EventScheduled"), {
                    className: "top-alert",
                    position: "top-center",
                    type: "success",
                    duration: 2000,
                  });
                }
              })
              .catch((error) => {
                this.$log.error(
                  "File : BookAppointment.vue | Function : schedule() | Error :",
                  error
                );
                this.show = false;
                // Error response
                this.error =
                  this.$t(error.replace(/[\s\/]/g, "")) !==
                  error.replace(/[\s\/]/g, "")
                    ? this.$t(error.replace(/[\s\/]/g, ""))
                    : error;
                this.$toasted.show(this.error, {
                  className: "top-alert",
                  position: "top-center",
                  type: "error",
                  duration: 2000,
                });
                return false;
              });
          }
        }
      });
    },
  },
};
</script>

<style>
.align-center {
  text-align: center;
}

.purchase {
  display: block !important;
}

#department {
  margin-top: 20px;
}

#update {
  display: inline-flex;
}

#cancel {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  margin-left: 20px;
  margin-top: 20px;
}

.contact_number {
  padding: 8px !important;
}

#contact_label {
  margin-top: 15px;
}

.charge td {
  width: 100%;
}

.marked-class {
  background-color: aliceblue !important;
  color: #00a2ff !important;
  cursor: pointer;
}
.vfc-marked {
  background-color: #66b3cc !important;
  color: #ffff !important;
}
.vfc-main-container {
  font-family: "Montserrat", Helvetica, Arial, sans-serif;
  border-radius: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.vfc-disabled.vfc-today {
  background-color: transparent !important;
}
.marked-class .vfc-today {
  background-color: transparent;
}

.sbtn {
  border: 1px solid rgba(0, 162, 255, 0.5);
  color: rgb(0, 162, 255);
  background-color: white;
  cursor: pointer;
}

.active {
  background-color: rgb(0, 162, 255);
  color: white;
  cursor: pointer;
}
</style>










